import ArticlesList from "../jsons/articles.json";
import CasesList from '../jsons/cases.json';

import ArticlesGrid from "./ArticlesGrid";


import MainCase from "./MainCase";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const ArticlesEventsCases = () => {
  const selectedCase = CasesList[0];
  const selectedIndustryName = "Healthcare";
  const featuredArticleIds = [25, 29, 30];
  const featuredArticles = featuredArticleIds
    .map((id) => ArticlesList.find((article) => article.id === id))
    .filter(Boolean);

  return (
    <>
      <section className="articleEventCasesWrapper">
        <div className="containerFull">
          <div className="subsection-articles">
            <h3>
              Insights and{" "}
              <span className="text-orange-violet-pink">case studies</span>.
            </h3>
            <div className="title-underline orange-violet-pink"></div>

            <div className="articles-wrapper">
              <div>
                <li></li>
              </div>
              <div className="articles-grid">
                <Swiper
                  slidesPerView={'auto'}
                  centeredSlides={false}
                  spaceBetween={10}
                  breakpoints={{
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    900: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    }
                  }}
                >
                  {featuredArticles.map((article) => (
                    <SwiperSlide key={article.id}>
                      <ArticlesGrid
                        title={article.title}
                        category={article.category}
                        capabilities={article.capabilities}
                        image={article.thumbnail}
                        slug={article.slug}
                      />
                    </SwiperSlide>

                  ))}
                </Swiper>

              </div>
            </div>

            <div className="bgCircle bgCircle-violet bgBlur-right-top"></div>
            <div className="bgCircle bgCircle-orange bgBlur-left-top"></div>
            <div className="bgCircle bgCircle-blue bgBlur-right-bottom"></div>
          </div>
        </div>
      </section>
      <MainCase 
        industryName = { selectedIndustryName }
        selectedCase={selectedCase} 
        titleColor="text-orange-violet-pink"
        arrow="var(--tangerine-orange)" 
      />
    </>
  );
};

export default ArticlesEventsCases;
